import { jsx as t } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
/* empty css          */
import m from "classnames";
import { useState as p, useEffect as s } from "../../../external/preact/hooks/dist/hooks.module.js";
const e = {
  "angle-right": () => import("../../../images/icons/angle-right.svg.js"),
  "checkmark-circle-fill": () => import("../../../images/icons/checkmark-circle-fill.svg.js"),
  "checkmark-square-fill": () => import("../../../images/icons/checkmark-square-fill.svg.js"),
  checkmark: () => import("../../../images/icons/checkmark.svg.js"),
  "chevron-down": () => import("../../../images/icons/chevron-down.svg.js"),
  "chevron-left": () => import("../../../images/icons/chevron-left.svg.js"),
  "chevron-right": () => import("../../../images/icons/chevron-right.svg.js"),
  "chevron-up": () => import("../../../images/icons/chevron-up.svg.js"),
  copy: () => import("../../../images/icons/copy.svg.js"),
  "cross-circle-fill": () => import("../../../images/icons/cross-circle-fill.svg.js"),
  cross: () => import("../../../images/icons/cross.svg.js"),
  download: () => import("../../../images/icons/download.svg.js"),
  "external-link": () => import("../../../images/icons/external-link.svg.js"),
  filter: () => import("../../../images/icons/filter.svg.js"),
  "info-filled": () => import("../../../images/icons/info-filled.svg.js"),
  "minus-circle-outline": () => import("../../../images/icons/minus-circle-outline.svg.js"),
  "plus-circle-outline": () => import("../../../images/icons/plus-circle-outline.svg.js"),
  square: () => import("../../../images/icons/square.svg.js"),
  "trash-can": () => import("../../../images/icons/trash-can.svg.js"),
  upload: () => import("../../../images/icons/upload.svg.js"),
  "warning-filled": () => import("../../../images/icons/warning-filled.svg.js"),
  warning: () => import("../../../images/icons/warning.svg.js")
}, d = ({ className: n, name: o, ...c }) => {
  const [r, i] = p(null);
  return s(() => {
    e[o] ? e[o]().then(({ default: l }) => {
      i(/* @__PURE__ */ t(l, {}));
    }) : (i(null), console.error(`Icon with name "${o}" does not exist.`));
  }, [o]), r && /* @__PURE__ */ t("span", { className: m("adyen-pe-icon", n), role: "img", "aria-hidden": !0, ...c, children: r });
};
export {
  d as Icon,
  d as default
};
